export default __webpack_public_path__ + "static/media/spark_68.88199d37.png";